import { render, staticRenderFns } from "./CompanionCard.vue?vue&type=template&id=3d5315a6&scoped=true&"
import script from "./CompanionCard.vue?vue&type=script&lang=js&"
export * from "./CompanionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5315a6",
  null
  
)

export default component.exports